import { render, staticRenderFns } from "./subtitle.vue?vue&type=template&id=75b849a4&scoped=true&"
import script from "./subtitle.vue?vue&type=script&lang=js&"
export * from "./subtitle.vue?vue&type=script&lang=js&"
import style0 from "./subtitle.vue?vue&type=style&index=0&id=75b849a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b849a4",
  null
  
)

export default component.exports